import { DRAG_HANDLE_WIDTH } from "./common.const";

export const RIGHTBAR_REPORT_CHART_WIDTH = "900px";

const REPORT_CHART_DRAWER_DEFAULT_TOTAL_WIDTH = parseInt(
  RIGHTBAR_REPORT_CHART_WIDTH,
  10,
);

export const REPORT_CHART_DRAWER_RESIZE_HANDLE_WIDTH = DRAG_HANDLE_WIDTH;
export const REPORT_CHART_DRAWER_DEFAULT_WIDTH =
  REPORT_CHART_DRAWER_DEFAULT_TOTAL_WIDTH;
export const REPORT_CHART_DRAWER_MIN_WIDTH = 480;
export const REPORT_CHART_DRAWER_RESIZE_KEYBOARD_STEP = 20;
